import {
    // Pre-order Summary
    PRE_ORDER_EVENT_OVERVIEW_REQUEST,
    PRE_ORDER_EVENT_OVERVIEW_SUCCESS,
    PRE_ORDER_EVENT_OVERVIEW_FAILURE,

    PRE_ORDER_BY_ORDER_DATE_REQUEST,
    PRE_ORDER_BY_ORDER_DATE_SUCCESS,
    PRE_ORDER_BY_ORDER_DATE_FAILURE,

    PRE_ORDER_BY_PICKUP_SLOT_REQUEST,
    PRE_ORDER_BY_PICKUP_SLOT_SUCCESS,
    PRE_ORDER_BY_PICKUP_SLOT_FAILURE,

    PRE_ORDERS_BY_CHANNELS_REQUEST,
    PRE_ORDERS_BY_CHANNELS_SUCCESS,
    PRE_ORDERS_BY_CHANNELS_FAILURE,

    // Pre-order Details
    PRE_ORDER_DETAILS_REQUEST,
    PRE_ORDER_DETAILS_SUCCESS,
    PRE_ORDER_DETAILS_FAILURE,
    EVENT_NAME_FILTER_VALUES_REQUEST,
    EVENT_NAME_FILTER_VALUES_SUCCESS,
    EVENT_NAME_FILTER_VALUES_FAILURE,

    EVENT_PRE_ORDER_BY_PICKUP_SLOT_DATE_REQUEST,
    EVENT_NAME_GOLBAL,
    EVENT_DATES,
    EVENT_START_DATE,
    EVENT_END_DATE,
    EVENT_SELECTED_DATE_FILTER_TYPE,
    EVENT_SLOTS_FILTER_REQUEST,
    EVENT_SLOTS_FILTER_SUCCESS,
    EVENT_SLOTS_FILTER_FAILURE,
    EVENT_SELECTED_TIME_SLOT,
    PRE_ORDER_SUMMARY_GLOBAL_START_DATE,
    PRE_ORDER_SUMMARY_GLOBAL_END_DATE,
    PRE_ORDER_SUMMARY_GLOBAL_SELECTED_DATE_FILTER_TYPE
} from "./eventReportsConstants";


// Pre-order Summary
export const preOrderEventOverviewRequest = (data) => {
    return {
        type: PRE_ORDER_EVENT_OVERVIEW_REQUEST,
        payload: data
    };
}

export const preOrderEventOverviewSuccess = (data) => {
    return {
        type: PRE_ORDER_EVENT_OVERVIEW_SUCCESS,
        payload: data
    };
}

export const preOrderEventOverviewFailure = (error) => {
    return {
        type: PRE_ORDER_EVENT_OVERVIEW_FAILURE,
        payload: error
    };
}

export const preOrderByOrderDateRequest = (data) => {
    return {
        type: PRE_ORDER_BY_ORDER_DATE_REQUEST,
        payload: data
    };
}

export const preOrderByOrderDateSuccess = (data) => {
    return {
        type: PRE_ORDER_BY_ORDER_DATE_SUCCESS,
        payload: data
    };
}

export const preOrderByOrderDateFailure = (error) => {
    return {
        type: PRE_ORDER_BY_ORDER_DATE_FAILURE,
        payload: error
    };
}

export const preOrderByPickupSlotRequest = (data) => {
    return {
        type: PRE_ORDER_BY_PICKUP_SLOT_REQUEST,
        payload: data
    };
}

export const preOrderByPickupSlotSuccess = (data) => {
    return {
        type: PRE_ORDER_BY_PICKUP_SLOT_SUCCESS,
        payload: data
    };
}

export const preOrderByPickupSlotFailure = (error) => {
    return {
        type: PRE_ORDER_BY_PICKUP_SLOT_FAILURE,
        payload: error
    };
}

export const preOrdersByChannelsRequest = (data) => {
    return {
        type: PRE_ORDERS_BY_CHANNELS_REQUEST,
        payload: data
    };
}

export const preOrdersByChannelsSuccess = (data) => {
    return {
        type: PRE_ORDERS_BY_CHANNELS_SUCCESS,
        payload: data
    };
}

export const preOrdersByChannelsFailure = (error) => {
    return {
        type: PRE_ORDERS_BY_CHANNELS_FAILURE,
        payload: error
    };
}

// Pre-order Details
export const preOrderDetailsRequest = (data) => {
    return {
        type: PRE_ORDER_DETAILS_REQUEST,
        payload: data
    };
}

export const preOrderDetailsSuccess = (data) => {
    return {
        type: PRE_ORDER_DETAILS_SUCCESS,
        payload: data
    };
}

export const preOrderDetailsFailure = (error) => {
    return {
        type: PRE_ORDER_DETAILS_FAILURE,
        payload: error
    };
}

// Event Name Filter Values :
export const eventNameFilterValuesRequest = (data) => {
    return {
        type: EVENT_NAME_FILTER_VALUES_REQUEST,
        payload: data,
    }
}
export const eventNameFilterValuesSuccess = (data) => {
    return {
        type: EVENT_NAME_FILTER_VALUES_SUCCESS,
        payload: data,
    }
}
export const eventNameFilterValuesFailure = (error) => {
    return {
        type: EVENT_NAME_FILTER_VALUES_FAILURE,
        payload: error,
    }
}

export const changEventPreOrderByPickupSlotDate = (data) => {
    return {
        type: EVENT_PRE_ORDER_BY_PICKUP_SLOT_DATE_REQUEST,
        payload: data,
    }
}

export const changeEvent = (data) => {
    return {
        type: EVENT_NAME_GOLBAL,
        payload: data,
    }
}

export const changEventStartDate = (data) => {
    return {
        type: EVENT_START_DATE,
        payload: data,
    }    
}

export const changEventEndDate = (data) => {
    return {
        type: EVENT_END_DATE,
        payload: data,
    }    
}

export const changeSelectedDateFilterType = (data) => {
    return {
        type: EVENT_SELECTED_DATE_FILTER_TYPE,
        payload: data,
    }    
}

// Event Slots Filter :
export const eventSlotsFilterRequest = (data) => {
    return {
        type: EVENT_SLOTS_FILTER_REQUEST,
        payload: data,
    }
}
export const eventSlotsFilterSuccess = (data) => {
    return {
        type: EVENT_SLOTS_FILTER_SUCCESS,
        payload: data,
    }
}
export const eventSlotsFilterFailure = (error) => {
    return {
        type: EVENT_SLOTS_FILTER_FAILURE,
        payload: error,
    }
}

// Event Selected Slot
export const eventSelectedTimeSlot = (data) => {
    return {
        type: EVENT_SELECTED_TIME_SLOT,
        payload: data,
    }
}

// Pre-Order Summary Global Start Date :
export const preOrderSummaryGlobalStartDate = (data) => {
    return {
        type: PRE_ORDER_SUMMARY_GLOBAL_START_DATE,
        payload: data,
    }
}

// Pre-Order Summary Global End Date :
export const preOrderSummaryGlobalEndDate = (data) => {
    return {
        type: PRE_ORDER_SUMMARY_GLOBAL_END_DATE,
        payload: data,
    }
}

// Pre-Order Summary Global Selected Date Filter Type :
export const preOrderSummaryGlobalSelectedDateFilterType = (data) => {
    return {
        type: PRE_ORDER_SUMMARY_GLOBAL_SELECTED_DATE_FILTER_TYPE,
        payload: data,
    }
}
